import { Component, OnInit } from "@angular/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { ConfirmationService } from "primeng/api";
import { UserService } from "../../../../shared";
import { DistCalData } from "../DistCalData";
import { CalendarDayInfo } from "../CalendarDayInfo";
import { DistrictAdministrationService } from "../../services/districtadministration.service";
import * as moment from "moment";

@Component({
	selector: "caass-district-calendar-main-view",
	templateUrl: "./district-calendar-main-view.component.html",
	styleUrls: ["./district-calendar-main-view.component.css"],
})
export class DistrictCalendarMainViewComponent implements OnInit {
	constructor(private districtService: DistrictAdministrationService, private confirmationService: ConfirmationService, private userService: UserService) {}

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		////////////////////
		// Full Calendar
		////////////////////

		//Get events to display on the calendar
		this.initEvents();

		//Set up calendar options
		this.options = {
			plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
			defaultDate: moment(new Date()).format("YYYY-MM-DD"),
			initialView: "dayGridMonth",
			headerToolbar: {
				left: "prev,next",
				center: "title",
				right: "dayGridMonth,timeGridWeek,timeGridDay",
			},
			//Handle Event Clicks Here
			// eventClick: (e) =>  {
			//   //e.event is the event entry that was clicked
			// }
		};

		////////////////////

		////////////////////
		// Manual Calendar
		////////////////////

		//Get list of years
		this.initYearsList();

		//Get Day entries based on calendar month + data from DB
		this.initDays();
		////////////////////
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	user: any;

	////////////////////
	//Full Calendar
	////////////////////
	events: any = [];
	options: any;
	////////////////////

	////////////////////
	//Manual Calendar
	////////////////////
	DBData: any = [];

	Days: any = [];
	OriginalDays: any = [];

	//Date/Month that is selected
	//Default is current day
	SelectedDate: Date = new Date();

	// SelectedMonth: any = this.IntToMonth(new Date().getMonth());
	// SelectedYear: any = this.SelectedDate.getFullYear();

	DisplayMonth: any = this.IntToMonth(new Date().getMonth());
	lstMonth: any = ["January", "Febuary", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

	DisplayYear: any = new Date().getFullYear();
	lstYear: any = [];

	lstChangedData: any = [];

	////////////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	initEvents() {
		while (this.events.length > 0) {
			this.events.pop();
		}

		this.events = [
			{
				title: "Today",
				start: moment(new Date()).format("YYYY-MM-DD").toString(),
				end: moment(new Date()).format("YYYY-MM-DD").toString(),
				id: "0",
			},
		];
	}

	initDays() {
		//Get Data from SP (list of selected month's days that are open or not open)
		var lstOpenValues: any = [];

		//1st of the month
		var StartDate = new Date(this.SelectedDate.getFullYear(), this.SelectedDate.getMonth(), 1);

		//Last of the month
		var EndDate = new Date(this.SelectedDate.getFullYear(), this.SelectedDate.getMonth() + 1, 0);

		var result = this.districtService.GetCalendarInfo(moment(StartDate).format("MM/DD/YYYY"), moment(EndDate).format("MM/DD/YYYY"), 0);
		result.subscribe(
			(response) => {
				lstOpenValues = response;

				//Create days based on data
				this.CreateDays(lstOpenValues);
			},
			(error) => {}
		);
	}

	CreateDays(lstOpenValues) {
		//Clear data
		this.Days = [];
		this.OriginalDays = [];

		//Find Month/Day 1 Day of week
		var CurrentDate: Date = this.SelectedDate;
		CurrentDate.setDate(1);

		//Get 1st of the month's day of the week
		var StartDOW = CurrentDate.getDay() + 1; //Default is 0 based, change it to 1 based

		//Get days in the month by getting the month's last day
		var DIMDay = new Date(CurrentDate.getFullYear(), CurrentDate.getMonth() + 1, 0);
		var DaysInMonth = DIMDay.getDate();

		//Index for day of month
		var DayInd = 1;

		//Keep track of index in incomplete list
		var incompleteIndex = 0;

		//Create Days (7x5 grid so 35 days, some are blank)
		for (var i = 1; i <= 42; i++) {
			//Need separate values for current data
			//and original data (to check if data was changed)
			let nextVal: any;
			let originalVal: any;

			//Blank days
			if (i < StartDOW || DayInd > DaysInMonth) {
				nextVal = {
					CalendarID: -1,
					BellScheduleID: -1,
					SchoolID: -1,
					DayID: -1,
					CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
					Comment: "",
					DayNumber: -1,
					IsOpen: false,
					c_date: new Date(),
				};
				originalVal = {
					CalendarID: -1,
					BellScheduleID: -1,
					SchoolID: -1,
					DayID: -1,
					CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
					Comment: "",
					DayNumber: -1,
					IsOpen: false,
					c_date: new Date(),
				};
			}
			//Days w/ a Day Number
			//Use data to set open or closed
			else if (lstOpenValues.length == DaysInMonth) {
				if (lstOpenValues.length > 0 && lstOpenValues.length >= DayInd) {
					nextVal = {
						CalendarID: lstOpenValues[DayInd - 1].CalendarID,
						BellScheduleID: lstOpenValues[DayInd - 1].BellScheduleID,
						SchoolID: -1,
						DayID: lstOpenValues[DayInd - 1].DayID,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: lstOpenValues[DayInd - 1].Comment,
						DayNumber: DayInd,
						IsOpen: lstOpenValues[DayInd - 1].IsOpen == 1 ? true : false, //DayInd 1 based, array is 0 based
						c_date: lstOpenValues[DayInd - 1].c_date,
					};
					originalVal = {
						CalendarID: lstOpenValues[DayInd - 1].CalendarID,
						BellScheduleID: lstOpenValues[DayInd - 1].BellScheduleID,
						SchoolID: -1,
						DayID: lstOpenValues[DayInd - 1].DayID,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: lstOpenValues[DayInd - 1].Comment,
						DayNumber: DayInd,
						IsOpen: lstOpenValues[DayInd - 1].IsOpen == 1 ? true : false, //DayInd 1 based, array is 0 based
						c_date: lstOpenValues[DayInd - 1].c_date,
					};
				}
				//Create new entry (Value in in data set)
				else {
					nextVal = {
						CalendarID: -1,
						BellScheduleID: -1,
						SchoolID: -1,
						DayID: -1,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: "",
						DayNumber: DayInd,
						IsOpen: false,
						c_date: new Date(),
					};
					originalVal = {
						CalendarID: -1,
						BellScheduleID: -1,
						SchoolID: -1,
						DayID: -1,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: "",
						DayNumber: DayInd,
						IsOpen: false,
						c_date: new Date(),
					};
				}

				DayInd++;
			} else if (lstOpenValues.length < DaysInMonth) {
				var next: any = null;
				var DateOfNext: any = null;

				if (incompleteIndex < lstOpenValues.length) {
					//Check next entry in incomplete list
					next = lstOpenValues[incompleteIndex];
					DateOfNext = new Date(next.CalendarDate);
				}

				//Add day's value if it is the next date
				if (next != null && DateOfNext != null && DateOfNext.getDate() == DayInd && incompleteIndex < lstOpenValues.length) {
					nextVal = {
						CalendarID: lstOpenValues[incompleteIndex].CalendarID,
						BellScheduleID: lstOpenValues[incompleteIndex].BellScheduleID,
						SchoolID: -1,
						DayID: lstOpenValues[incompleteIndex].DayID,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: lstOpenValues[incompleteIndex].Comment,
						DayNumber: DayInd,
						IsOpen: lstOpenValues[incompleteIndex].IsOpen == 1 ? true : false, //DayInd 1 based, array is 0 based
						c_date: lstOpenValues[incompleteIndex].c_date,
					};
					originalVal = {
						CalendarID: lstOpenValues[incompleteIndex].CalendarID,
						BellScheduleID: lstOpenValues[incompleteIndex].BellScheduleID,
						SchoolID: -1,
						DayID: lstOpenValues[incompleteIndex].DayID,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: lstOpenValues[incompleteIndex].Comment,
						DayNumber: DayInd,
						IsOpen: lstOpenValues[incompleteIndex].IsOpen == 1 ? true : false, //DayInd 1 based, array is 0 based
						c_date: lstOpenValues[incompleteIndex].c_date,
					};

					incompleteIndex++;
				}
				//Add blank day
				else {
					nextVal = {
						CalendarID: -1,
						BellScheduleID: -1,
						SchoolID: -1,
						DayID: -1,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: "",
						DayNumber: DayInd,
						IsOpen: false,
						c_date: new Date(),
					};
					originalVal = {
						CalendarID: -1,
						BellScheduleID: -1,
						SchoolID: -1,
						DayID: -1,
						CalendarDate: moment(new Date(CurrentDate.getFullYear(), CurrentDate.getMonth(), DayInd)).format("YYYY-MM-DD"),
						Comment: "",
						DayNumber: DayInd,
						IsOpen: false,
						c_date: new Date(),
					};
				}

				DayInd++;
			}

			//Update both lists
			this.Days = [...this.Days, nextVal];
			this.OriginalDays = [...this.OriginalDays, originalVal];
		}

		this.GetChangedData();
	}

	initYearsList() {
		var Today = new Date();
		var CurrentYear = Today.getFullYear();

		//Get this year + next year (Can't modify days that already happened)
		this.lstYear = [CurrentYear, CurrentYear + 1];

		//Could check what years are in the school year?
		//Ex. January -> June/July = year - 1, year
		//July -> December = year, year + 1
	}

	GetChangedData() {
		this.lstChangedData = [];

		for (var i = 0; i < this.Days.length; i++) {
			if (this.Days[i].IsOpen != this.OriginalDays[i].IsOpen) {
				this.lstChangedData = [...this.lstChangedData, this.Days[i]];
			}
		}
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////
	onUpdate() {
		this.GetChangedData();

		if (this.lstChangedData.length == 0) {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "No data was changed",
				header: "Save Data",
				icon: "fa",
				accept: () => {},
			});

			return;
		}

		//Apply to all schools popup
		this.ApplyToAllSchools();
	}

	ApplyToAllSchools() {
		this.confirmationService.confirm({
			key: "Main",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Would you like to apply the changes to all schools' calendars?",
			header: "Save Data",
			icon: "fa",

			//Call SP based on input
			accept: () => {
				this.ModifyCalendarList(1);
			},
			reject: () => {
				this.ModifyCalendarList(0);
			},
		});
	}

	ApplyToAllSchoolsAuto(ChangedData) {
		this.confirmationService.close();

		this.confirmationService.confirm({
			key: "Auto",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Would you like to apply the changes to all schools' calendars?",
			header: "Save Data",
			icon: "fa",

			//Call SP based on input
			accept: () => {
				this.ModifyCalendar(1, ChangedData);
			},
			reject: () => {
				this.ModifyCalendar(0, ChangedData);
			},
		});

		// this.ModifyCalendar(0, ChangedData); ///////////////////////////////////////////////////////////////
	}

	//Update when date is changed
	onAutoUpdate(ChangedData) {
		//Apply to all schools popup
		this.confirmationService.confirm({
			key: "Main",
			acceptLabel: "Save Changes",
			rejectLabel: "Discard Changes",
			rejectVisible: true,
			message: "Data was changed, would you like to save or discard changes?",
			header: "Data Changed",
			icon: "fa",
			//Call SP based on input
			accept: () => {
				this.ApplyToAllSchoolsAuto(ChangedData);
			},
			reject: () => {
				this.initDays();
			},
		});
	}

	ModifyCalendarList(ApplyToAll) {
		//Call SP for list of entries
		this.ModifyCalendar(ApplyToAll, this.lstChangedData);
	}

	ModifyCalendar(ApplyToAll, Data) {
		//
		//Set up parameters
		//
		let lstCD: CalendarDayInfo[] = [];

		for (var i = 0; i < Data.length; i++) {
			var next = Data[i];

			var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> Jluy 9th
			nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

			let val1: CalendarDayInfo = {
				CalendarID: next.CalendarID,
				BellScheduleID: next.BellScheduleID,
				SchoolID: -1,
				DayID: next.DayID,
				CalendarDate: nextDate,
				Comment: next.Comment,
				IsOpen: next.IsOpen == true ? 1 : 0,
			};

			lstCD = [...lstCD, val1];
		}

		let parms: DistCalData = {
			ApplyToAll: ApplyToAll,
			UserID: this.user.userID,
			CalendarDays: lstCD,
		};

		var result = this.districtService.CalendarModifyWithData(parms);

		result.subscribe(
			(response) => {
				if (response) {
					//Success
					this.confirmationService.confirm({
						key: "Finish",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "All changes were made successfully",
						header: "Calendar Modified",
						icon: "fa",
						accept: () => {
							this.initDays();
						},
					});
				} else {
					//Error
					this.confirmationService.confirm({
						key: "Finish",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not update district calendar",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onReset() {
		for (var i = 0; i < this.Days.length; i++) {
			this.Days[i].IsOpen = this.OriginalDays[i].IsOpen;
		}

		this.lstChangedData = [];
	}

	onSelectAllWeekdays() {
		for (var i = 0; i < this.Days.length; i++) {
			var next = this.Days[i];

			//Get the date of the selected day
			var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> Jluy 9th
			nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

			//Get the day of the week
			var DOW = nextDate.getDay();

			//If it's a weekday, set it to be open
			if (next.DayNumber != -1 && DOW != 0 && DOW != 6) {
				next.IsOpen = true;
			}
		}

		this.GetChangedData();
	}

	onDeselectAllWeekdays() {
		for (var i = 0; i < this.Days.length; i++) {
			var next = this.Days[i];

			//Get the date of the selected day
			var nextDate = new Date(next.CalendarDate); //Date off by 1 (1 day before the real day), July 10th -> Jluy 9th
			nextDate = new Date(nextDate.getFullYear(), nextDate.getMonth(), nextDate.getDate() + 1);

			//Get the day of the week
			var DOW = nextDate.getDay();

			//If it's a weekday, set it to be open
			if (next.DayNumber != -1 && DOW != 0 && DOW != 6) {
				next.IsOpen = false;
			}
		}

		this.GetChangedData();
	}

	onNext() {
		//Get Month Index
		var MIndex = this.MonthToInt(this.DisplayMonth);
		var YIndex = 0;
		for (var i = 0; i < this.lstYear.length; i++) {
			if (this.lstYear[i] == this.DisplayYear) {
				YIndex = i;
			}
		}

		//If month is not the last in the list, increment month
		if (MIndex < this.lstMonth.length - 1) {
			this.onDisplayMonthChange(this.lstMonth[MIndex + 1]);
		}

		//Else try to go the next year (if possible)
		else {
			if (this.DisplayYear < this.lstYear[this.lstYear.length - 1]) {
				this.onDisplayMonthChange(this.lstMonth[0]);
				this.onDisplayYearChange(this.lstYear[YIndex + 1]);
			}
		}
	}

	DisableNext() {
		var MIndex = this.MonthToInt(this.DisplayMonth);

		return this.DisplayYear == this.lstYear[this.lstYear.length - 1] && MIndex == this.lstMonth.length - 1;
	}

	onPrevious() {
		//Get Month Index
		var MIndex = this.MonthToInt(this.DisplayMonth);
		var YIndex = 0;
		for (var i = 0; i < this.lstYear.length; i++) {
			if (this.lstYear[i] == this.DisplayYear) {
				YIndex = i;
			}
		}

		//If month is not the last in the list, increment month
		if (MIndex > 0) {
			this.onDisplayMonthChange(this.lstMonth[MIndex - 1]);
		}

		//Else try to go the next year (if possible)
		else {
			if (this.DisplayYear > this.lstYear[0]) {
				this.onDisplayMonthChange(this.lstMonth[this.lstMonth.length - 1]);
				this.onDisplayYearChange(this.lstYear[YIndex - 1]);
			}
		}
	}

	DisablePrevious() {
		var MIndex = this.MonthToInt(this.DisplayMonth);

		return this.DisplayYear == this.lstYear[0] && MIndex == 0;
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////

	//Update array of data when a day's checkbox is clicked
	onDayChange(val) {
		for (var i = 0; i < this.Days.length; i++) {
			var next = this.Days[i];

			if (next.DayNumber == val.DayNumber) {
				next.IsOpen = val.IsOpen;

				break;
			}
		}

		//Might get rid of, updates list of changed data
		this.GetChangedData();
	}

	//Select a new date to view
	onDisplay() {}
	onDisplayMonthChange(val) {
		this.DisplayMonth = val;

		//Check if data was changed?
		this.GetChangedData();

		this.SelectedDate = new Date(this.SelectedDate.getFullYear(), this.MonthToInt(this.DisplayMonth), 1);

		//If yes, ask if user wants to save
		if (this.lstChangedData.length > 0) {
			this.onAutoUpdate(this.lstChangedData);
			return;
		}

		//Load new days
		//Load new data from SP
		this.initDays();
	}

	onDisplayYearChange(val) {
		this.DisplayYear = val;

		//Check if data was changed?
		this.GetChangedData();

		this.SelectedDate = new Date(Number(this.DisplayYear), this.SelectedDate.getMonth(), 1);

		//If yes, ask if user wants to save
		if (this.lstChangedData.length > 0) {
			this.onAutoUpdate(this.lstChangedData);
			return;
		}

		//Load new days
		//Load new data from SP
		this.initDays();
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	//JS Month, 0 based
	IntToMonth(i) {
		if (i == 0) {
			return "January";
		} else if (i == 1) {
			return "Febuary";
		} else if (i == 2) {
			return "March";
		} else if (i == 3) {
			return "April";
		} else if (i == 4) {
			return "May";
		} else if (i == 5) {
			return "June";
		} else if (i == 6) {
			return "July";
		} else if (i == 7) {
			return "August";
		} else if (i == 8) {
			return "September";
		} else if (i == 9) {
			return "October";
		} else if (i == 10) {
			return "November";
		} else if (i == 11) {
			return "December";
		}
	}

	MonthToInt(m) {
		if (m == "January") {
			return 0;
		} else if (m == "Febuary") {
			return 1;
		} else if (m == "March") {
			return 2;
		} else if (m == "April") {
			return 3;
		} else if (m == "May") {
			return 4;
		} else if (m == "June") {
			return 5;
		} else if (m == "July") {
			return 6;
		} else if (m == "August") {
			return 7;
		} else if (m == "September") {
			return 8;
		} else if (m == "October") {
			return 9;
		} else if (m == "November") {
			return 10;
		} else if (m == "December") {
			return 11;
		}
	}

	IsToday(DayNumber) {
		var Today = new Date();

		return Today.getFullYear() == this.SelectedDate.getFullYear() && Today.getMonth() == this.SelectedDate.getMonth() && Today.getDate() == DayNumber;
	}

	////////////////////////////////////////////
}
